// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes appear {
  from {
    opacity: 0.5;
    scale: 0.8;
  }

  80% {
    scale: 1.05;
  }

  to {
    opacity: 1;
    scale: 1;
  }
}


.intelibly-map {
  width: 100%;
  height: 100%;
}

.intelibly-map .marker {
  box-sizing: border-box;
  border-radius: 50%;
  padding: 0;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  border: none;
  outline: none;
  animation: appear 150ms both;
}

.intelibly-map .marker svg {
  width: 100%;
  vector-effect: non-scaling-stroke;
}

.intelibly-map .marker.feature {
  width: 40px;
  height: 40px;
  background-color: #3f5b72;
  filter: drop-shadow(1px 2px 3px rgba(0, 0, 0, 0.5));
}

.intelibly-map .marker.cluster {
  width: 40px;
  height: 40px;
  background-color: #618bad;
  filter: drop-shadow(2px 4px 12px rgba(0, 0, 0, 0.7));
  overflow: hidden;
  padding-bottom: 0;
}

.intelibly-map .marker-cluster-content {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--intelibly-branding-primary-100);
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  border: 1px solid var(--intelibly-branding-primary-700);
  background-color: var(--intelibly-branding-primary-600);
} `, "",{"version":3,"sources":["webpack://./src/intelibly-map-styles.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,QAAQ;EACV;AACF;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oDAAoD;EACpD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,eAAe;EACf,qCAAqC;EACrC,uDAAuD;EACvD,uDAAuD;AACzD","sourcesContent":["@keyframes appear {\n  from {\n    opacity: 0.5;\n    scale: 0.8;\n  }\n\n  80% {\n    scale: 1.05;\n  }\n\n  to {\n    opacity: 1;\n    scale: 1;\n  }\n}\n\n\n.intelibly-map {\n  width: 100%;\n  height: 100%;\n}\n\n.intelibly-map .marker {\n  box-sizing: border-box;\n  border-radius: 50%;\n  padding: 0;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  border: none;\n  outline: none;\n  animation: appear 150ms both;\n}\n\n.intelibly-map .marker svg {\n  width: 100%;\n  vector-effect: non-scaling-stroke;\n}\n\n.intelibly-map .marker.feature {\n  width: 40px;\n  height: 40px;\n  background-color: #3f5b72;\n  filter: drop-shadow(1px 2px 3px rgba(0, 0, 0, 0.5));\n}\n\n.intelibly-map .marker.cluster {\n  width: 40px;\n  height: 40px;\n  background-color: #618bad;\n  filter: drop-shadow(2px 4px 12px rgba(0, 0, 0, 0.7));\n  overflow: hidden;\n  padding-bottom: 0;\n}\n\n.intelibly-map .marker-cluster-content {\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--intelibly-branding-primary-100);\n  font-size: 14px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.3);\n  border: 1px solid var(--intelibly-branding-primary-700);\n  background-color: var(--intelibly-branding-primary-600);\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
